<h1 mat-dialog-title>Edit Title, Description and Facilites</h1>
<div mat-dialog-content>
    <div class="row m-2">
        <form class="col-sm-12 row" [formGroup]="basicInfoForm">
            <div class="col-md-12 form-group">
                <label for="title">Title</label>
                <input class="form-control" id="title" formControlName="title" placeholder="Title">
            </div>
            <div class="col-md-12 form-group">
                <label for="description">Description</label>
                <angular-editor formControlName="details" [config]="editorConfig"></angular-editor>
            </div>
            <h3 class="col-sm-12 mt-4 mb-4 title">Major Facilities</h3>
            <div class="row col-sm-12">
                <div class="col-sm-12 row">
                    <div class="col-sm-12 col-md-6 form-group">
                        <label for="parking" class="w-100">Parking</label>
                        <div class="row ml-2" id="parking">
                            <div class="col-sm-6">
                                <input class="form-check-input" type="radio" formControlName="parking" id="available1" value="Available">
                                <label class="form-check-label" for="available1">
                                    Available
                                </label>
                            </div>
                            <div class="col-sm-6">
                                <input class="form-check-input" type="radio" formControlName="parking" id="notavailable1" value="Not Available">
                                <label class="form-check-label" for="notavailable1">
                                    Not Available
                                </label>
                            </div>
                        </div>
                        <hr class="divider">
                    </div>
                    <div class="col-sm-12 col-md-6 form-group">
                        <label for="waterSupply" class="w-100">Water Supply</label>
                        <div class="row ml-2" id="waterSupply">
                            <div class="col-sm-6">
                                <input class="form-check-input" type="radio" formControlName="waterSupply" id="available2" value="Available">
                                <label class="form-check-label" for="available2">
                                    Available
                                </label>
                            </div>
                            <div class="col-sm-6">
                                <input class="form-check-input" type="radio" formControlName="waterSupply" id="notavailable2" value="Not Available">
                                <label class="form-check-label" for="notavailable2">
                                    Not Available
                                </label>
                            </div>
                        </div>
                        <hr class="divider">
                    </div>
                    <div class="col-sm-12 col-md-6 form-group">
                        <label for="telecommunication" class="w-100">Telecommunication</label>
                        <div class="row ml-2" id="telecommunication">
                            <div class="col-sm-6">
                                <input class="form-check-input" type="radio" formControlName="telecommunication" id="available3" value="Available">
                                <label class="form-check-label" for="available3">
                                    Available
                                </label>
                            </div>
                            <div class="col-sm-6">
                                <input class="form-check-input" type="radio" formControlName="telecommunication" id="notavailable3" value="Not Available">
                                <label class="form-check-label" for="notavailable3">
                                    Not Available
                                </label>
                            </div>
                        </div>
                        <hr class="divider">
                    </div>
                    <div class="col-sm-12 col-md-6 form-group">
                        <label for="electricity" class="w-100">Electricity</label>
                        <div class="row ml-2" id="electricity">
                            <div class="col-sm-6">
                                <input class="form-check-input" type="radio" formControlName="electricity" id="available4" value="Available">
                                <label class="form-check-label" for="available4">
                                    Available
                                </label>
                            </div>
                            <div class="col-sm-6">
                                <input class="form-check-input" type="radio" formControlName="electricity" id="notavailable4" value="Not Available">
                                <label class="form-check-label" for="notavailable4">
                                    Not Available
                                </label>
                            </div>
                            <hr class="divider">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 form-group">
                        <label for="gasSupply" class="w-100">Gas Supply</label>
                        <div class="row ml-2" id="gasSupply">
                            <div class="col-sm-6">
                                <input class="form-check-input" type="radio" formControlName="gasSupply" id="available5" value="Available">
                                <label class="form-check-label" for="available5">
                                    Available
                                </label>
                            </div>
                            <div class="col-sm-6">
                                <input class="form-check-input" type="radio" formControlName="gasSupply" id="notavailable5" value="Not Available">
                                <label class="form-check-label" for="notavailable5">
                                    Not Available
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h3 class="col-sm-12 mt-4 mb-4 title">Other Facilities</h3>
            <div *ngIf="otherFacility" class="col-sm-12">
                <div class="row col-sm-12 relative" *ngFor="let form of otherFacility.get('forms')['controls']; let i = index">
                    <hr *ngIf="i != 0" class="divider">
                    <form [formGroup]="form" class="col-sm-12 row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label>Title</label>
                            <input class="form-control" formControlName="title" type="text" placeholder="Title of the available facility">
                        </div>
                        <div class="col-sm-12 col-md-6 form-group">
                            <label>Details</label>
                            <input class="form-control" formControlName="details" type="text" placeholder="Details about the facility">
                        </div>
                    </form>
                    <button mat-button *ngIf="i >= 0" class="remove-button" (click)="removeOtherFacilityAt(i)">X</button>
                </div>
                <div class="row pt-3">
                    <div class="col-sm-12 text-right">
                        <button (click)="addOtherFacility()">+ Add Facility</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<div mat-dialog-actions class="row col-sm-12 justify-content-end">
    <button mat-button mat-dialog-close>Close</button>
    <button mat-raised-button (click)="savePropertyBasicInfo()" cdkFocusInitial>Save</button>
</div>